import React from 'react'
import { Image, Segment, Header } from 'semantic-ui-react'

const BodyRebalanceHrvMetric = (props) => (
    <Segment>
        <Header as='h3'>
            Heart Rate change after an emotional event
        </Header>
        <Image src={`data:image/jpeg;base64,${props.body_rebalance_hrv_metric}`} alt={`${"hrv_body_rebalance.png"}`} centered/>
    </Segment>
)

export default BodyRebalanceHrvMetric



// WEBPACK FOOTER //
// ./src/components/participant-feel-data-reports/metrics/body-rebalance-hrv.js